import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import { RouteComponentProps } from 'react-router-dom';
import { dispatch } from '../bridge/events/dispatch';
import { DESTROY_CONTAINER } from '../bridge/events/types';
import { renderReceiptConfig } from '../bridge/methods';
import LeftBar from '../components/common/NavBar';
import { captureError } from './captureError';

type Props = RouteComponentProps<{ [k: string]: string }>;

const receiptConfigContainerId = 'receipt_config';

class ReceiptConfig extends PureComponent<Props, null> {
    componentDidMount(): void {
        const configs = {
            containerId: receiptConfigContainerId,
            routeParams: this.props.match.params,
            queryParams: this.props.location.search,
        };

        if (!window.RENDER_CONFIGS) {
            window.RENDER_CONFIGS = [];
        }

        window.RENDER_CONFIGS.push(configs);

        try {
            renderReceiptConfig(configs);
        } catch (e) {
            console.log(e);
            captureError(e as Error);
        }
    }

    componentWillUnmount(): void {
        dispatch({ type: DESTROY_CONTAINER, containerId: receiptConfigContainerId });
        // window.removeEventListener(EKA_EVENT, this.onEkaEvents);
        window.RENDER_CONFIGS = window.RENDER_CONFIGS?.filter(
            (renderConfig) => renderConfig.containerId !== receiptConfigContainerId,
        );
    }

    render(): React.ReactNode {
        return (
            <div className="flex flex-col w-full h-full bg-white font-lato">
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>EKA - Receipt Configuration</title>
                </Helmet>
                <div className="grid h-full overflow-x-auto overflow-y-hidden grid-cols-queueGrid min-w-840 undefined">
                    <LeftBar />
                    <div
                        id={receiptConfigContainerId}
                        className="flex flex-col h-full col-span-11 overflow-hidden"
                    ></div>
                </div>
            </div>
        );
    }
}

export default ReceiptConfig;
